import api, { setToken } from '../index';

export function getSchedule(data) {
  return api.get(`/schedule/${data.type}${data.url}`, setToken(data.token));
}

export function getEventDay(data) {
  return api.get(`/schedule/events?date=${data.date}`, setToken(data.token));
}
export function sendMakeupRequest(data) {
  return api.post('/schedule/makeup-request', {}, setToken(data.token));
}
